import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

/**
 * Route guard (§3.5): the session restore MUST complete before any redirect
 * decision. While Firebase is restoring we show a quiet loading screen —
 * never a bounce to /login. Once settled: no user → /login carrying the
 * intended destination, so login returns you exactly where you were headed.
 *
 * Wraps every authenticated route (legacy /agent, /client, /admin and the
 * new /app/*). Because children don't mount until the session is restored,
 * legacy componentDidMount fetches now always carry a token — the
 * refresh-logout bug class is closed for all of them at once.
 */

export function SessionRestoreScreen() {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--space-3)",
        color: "var(--gray-600)",
        fontFamily: "var(--font-sans)",
        fontSize: "var(--text-body)"
      }}
    >
      <span
        className="fk-btn__spinner"
        style={{ width: 22, height: 22, borderWidth: 2, color: "var(--green-700)" }}
      />
      Restoring your session…
    </div>
  );
}

function RequireAuth({ children }) {
  const { authReady, user } = useAuth();
  const location = useLocation();

  if (!authReady) {
    return <SessionRestoreScreen />;
  }
  if (!user) {
    const from = location.pathname + location.search;
    return <Navigate to="/login" replace state={{ from }} />;
  }
  return children;
}

export default RequireAuth;
